"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@chakra-ui/core");
const react_uid_1 = require("react-uid");
exports.NavbarMenuList = ({ menuGroups, }) => {
    const seed = react_uid_1.useUIDSeed();
    const MenuGroups = menuGroups.map((menuGroup, index) => {
        return (react_1.default.createElement(react_1.default.Fragment, { key: seed(menuGroup) },
            react_1.default.createElement(core_1.MenuGroup, { key: menuGroup.title, title: menuGroup.title }, menuGroup.menuItems.map(({ label, onClick }) => (react_1.default.createElement(core_1.MenuItem, { key: label, onClick: onClick }, label)))),
            index < menuGroups.length - 1 ? react_1.default.createElement(core_1.MenuDivider, null) : null));
    });
    return react_1.default.createElement(core_1.MenuList, null, MenuGroups);
};
exports.NavbarMenu = ({ menuConfig, }) => {
    if (!menuConfig)
        return null;
    const { name, menuGroups, avatarSrc } = menuConfig;
    const userAvatar = avatarSrc || 'https://bit.ly/broken-link';
    return (react_1.default.createElement(core_1.Menu, null,
        react_1.default.createElement(core_1.MenuButton, null,
            react_1.default.createElement(core_1.Avatar, { size: "sm", name: name, src: userAvatar })),
        react_1.default.createElement(exports.NavbarMenuList, { menuGroups: menuGroups })));
};
exports.default = exports.NavbarMenu;
